import React from 'react';
import './HistoryStats.css';
import Card from '../../../../components/Card/Card';
import Table from '../../../../components/Table/Table';
import { useSelector } from 'react-redux';
import { selectMonthStats } from '../../selectors';
import type { ShortStatsDto } from '@poker-stats/contracts';
import Text from '../../../../components/Text/Text';
import formatHands from '../../../../utils/formatHands';
import formatWinnings from '../../../../utils/formatWinnings';
import Flex from '../../../../components/Flex/Flex';

const HistoryStats = React.memo(() => {
  const monthStats = useSelector(selectMonthStats);

  if (monthStats.length === 0) {
    return (
      <Card title="History">
        <Flex className="HistoryStats__empty" justify="center" align="center">
          <Text>-</Text>
        </Flex>
      </Card>
    );
  }

  return (
    <Card title="History">
      <Table
        columns={[
          {
            title: '',
            dataIndex: 'month',
          },
          {
            title: 'Hands',
            dataIndex: 'hands',
            render: (x: ShortStatsDto) => <Text>{formatHands(x.hands, 1)}</Text>,
          },
          {
            title: 'Winnings',
            dataIndex: 'winnings',
            render: (x: ShortStatsDto) => (
              <Text type={x.winnings > 0 ? 'success' : 'error'}>
                {formatWinnings(x.winnings, 1, false)}
              </Text>
            ),
          },
          { title: 'bb/100', dataIndex: 'bb100' },
        ]}
        data={monthStats.filter((_, i) => i < 12)}
        pagination={false}
      />
    </Card>
  );
});

export default HistoryStats;
